// importing language icons:
import JavaScriptIcon from "../../../assets/tech-icons/javascript_icon.svg";
import TypeScriptIcon from "../../../assets/tech-icons/typescript_icon.svg";
import PythonIcon from "../../../assets/tech-icons/python_icon.svg";

// importing framework icons:
import DjangoIcon from "../../../assets/tech-icons/django_icon.svg";
import ReactJSIcon from "../../../assets/tech-icons/react_icon.svg";
import NextJSIcon from "../../../assets/tech-icons/nextjs_icon.svg";
import FastAPIIcon from "../../../assets/tech-icons/fastapi_icon.svg";
import SvelteIcon from "../../../assets/tech-icons/svelte_icon.svg";
import PytorchIcon from "../../../assets/tech-icons/pytorch_icon.svg";
import TensorFlowIcon from "../../../assets/tech-icons/tensorflow_icon.svg";

// importing tool icons:
import GitIcon from "../../../assets/tech-icons/git_icon.svg";
import FirebaseIcon from "../../../assets/tech-icons/firebase_icon.svg";
import GitHubIcon from "../../../assets/tech-icons/github_icon.svg";
import LinuxIcon from "../../../assets/tech-icons/linux_icon.svg";
import TerminalIcon from "../../../assets/tech-icons/terminal_icon.svg";
import PostgreSQLIcon from "../../../assets/tech-icons/postgresql_icon.svg";
import MongoDBIcon from "../../../assets/tech-icons/mongodb_icon.svg";
import VSCodeIcon from "../../../assets/tech-icons/vscode_icon.svg";
import DockerIcon from "../../../assets/tech-icons/docker_icon.svg";
import NginxIcon from "../../../assets/tech-icons/nginx_icon.svg";

export const Languages = [
  {
    img: PythonIcon,
    label: "Python",
    bgColor: "#ffc85133",
  },
  {
    img: TypeScriptIcon,
    label: "TypeScript",
    bgColor: "#007acc33",
  },
  {
    img: JavaScriptIcon,
    label: "JavaScript",
    bgColor: "#f7df1e33",
  },
];

export const Frameworks = [
  {
    img: DjangoIcon,
    label: "Django",
    bgColor: "#092E2033",
  },
  {
    img: DjangoIcon,
    label: "Django REST Framework",
    bgColor: "#092E2033",
  },
  {
    img: FastAPIIcon,
    label: "FastAPI",
    bgColor: "#00968833",
  },
  {
    img: ReactJSIcon,
    label: "React",
    bgColor: "#00d8ff33",
  },
  {
    img: NextJSIcon,
    label: "Next.js",
    bgColor: "#fff3",
  },
  {
    img: SvelteIcon,
    label: "Svelte",
    bgColor: "#FF3E0033",
  },
  {
    img: TensorFlowIcon,
    label: "TensorFlow",
    bgColor: "#FF6F0033",
  },
  {
    img: PytorchIcon,
    label: "PyTorch",
    bgColor: "#EE4C2C33",
  },
];

export const Automation = [
  {
    img: TerminalIcon,
    label: "RPA",
    bgColor: "#4B556333",
  },
  {
    img: TerminalIcon,
    label: "Workflow Automation",
    bgColor: "#2563EB33",
  },
  {
    img: TerminalIcon,
    label: "Playwright",
    bgColor: "#2EAD3333",
  },
  {
    img: TerminalIcon,
    label: "Selenium",
    bgColor: "#43B02A33",
  },
  {
    img: TerminalIcon,
    label: "Process Control",
    bgColor: "#37415133",
  },
];

export const Tools = [
  {
    img: PostgreSQLIcon,
    label: "PostgreSQL",
    bgColor: "#33679133",
  },
  {
    img: DockerIcon,
    label: "Docker",
    bgColor: "#2496ED33",
  },
  {
    img: NginxIcon,
    label: "Nginx",
    bgColor: "#00963933",
  },
  {
    img: GitIcon,
    label: "Git",
    bgColor: "#dd4c3533",
  },
  {
    img: LinuxIcon,
    label: "Linux",
    bgColor: "#FFCD0A33",
  },
  {
    img: MongoDBIcon,
    label: "MongoDB",
    bgColor: "#59963633",
  },
  {
    img: FirebaseIcon,
    label: "Firebase",
    bgColor: "#DD2C0033",
  },
  {
    img: GitHubIcon,
    label: "GitHub",
    bgColor: "#fff3",
  },
  {
    img: VSCodeIcon,
    label: "Visual Studio Code",
    bgColor: "#0065a933",
  },
];

export const AgentTools = [
  {
    img: TerminalIcon,
    label: "Codex",
    bgColor: "#fff3",
  },
  {
    img: TerminalIcon,
    label: "Claude Code",
    bgColor: "#D9775733",
  },
];